import React, { Component } from 'react';
import PropTypes from 'prop-types';


class Titlearea extends Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    preventEnter: PropTypes.bool,
    disableBreakLine: PropTypes.bool,
  }

  constructor(props) {
    super(props);

    this.state = {
      value: this.props.value,
    };
  }

  componentDidMount() {
    this.resize();
  }

  componentWillReceiveProps(props) {
    this.setState(props, this.resize);
  }

  onChange = (e) => {
    const { disableBreakLine } = this.props;
    let value = e.target.value;
    if (e.target.value && disableBreakLine) {
      const reg = /\r?\n|\r/g;
      value = value.replace(reg, ' ');
    }

    if (this.props.onChange) this.props.onChange(value);

    this.setState({
      value,
    }, this.resize);
  }

  onKeyPress = (event) => {
    const { preventEnter } = this.props;
    if (event.which === 13 /* Enter */) {
      if (preventEnter) event.preventDefault();
    }
  }

  resize = () => {
    while (this.textarea.clientHeight === this.textarea.scrollHeight && this.textarea.rows > 1) {
      if (this.textarea.rows === this.props.rows) break;
      this.textarea.rows -= 1;
    }

    while (this.textarea.clientHeight < this.textarea.scrollHeight) {
      this.textarea.rows += 1;
    }
  }

  render() {
    const textareaStyle = {
      resize: 'none',
    };

    const { onChange, value, preventEnter, disableBreakLine, ...other } = this.props;

    return (
      <textarea
        ref={(c) => { this.textarea = c; }}
        onChange={this.onChange}
        value={this.state.value}
        style={textareaStyle}
        onKeyPress={this.onKeyPress}
        {...other}
      >
        {this.props.textarea}
      </textarea>
    );
  }
}

export default Titlearea;
